import styled from 'styled-components';

export const PanelContainer = styled.div`
  width: 1280px;
  padding: 2em;
  display: grid;
  align-content: flex-start;
  grid-auto-rows: auto;
  grid-template-columns: 1fr 1fr;
  grid-gap: 2em;
`;
